import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import BlockHeaderCenter from 'components/common/BlockHeaderCenter';
import Colors from 'constants/colors';
import FontStyles from 'constants/font-styles';
import Button from 'components/common/Button';
import Image from 'components/common/Image';
import { NavLink } from 'react-router-dom';
import imgGiveBackPC1x from 'assets/images/PC/@1x/img_give_back.jpg';
import imgGiveBackPC2x from 'assets/images/PC/@2x/img_give_back@2x.jpg';
import imgGiveBackSP2x from 'assets/images/SP/@2x/img_give_back@2x.jpg';
import imgGiveBackSP3x from 'assets/images/SP/@3x/img_give_back@3x.jpg';
import imgGiveBackWebpPC1x from 'assets/images/PC/@1x/img_give_back.webp';
import imgGiveBackWebpPC2x from 'assets/images/PC/@2x/img_give_back@2x.webp';
import imgGiveBackWebpSP2x from 'assets/images/SP/@2x/img_give_back@2x.webp';
import imgGiveBackWebpSP3x from 'assets/images/SP/@3x/img_give_back@3x.webp';

const Give = ({ className }) => (
  <div className={className}>
    <Image
      pc1x={imgGiveBackPC1x}
      pc2x={imgGiveBackPC2x}
      sp2x={imgGiveBackSP2x}
      sp3x={imgGiveBackSP3x}
      webpPC1x={imgGiveBackWebpPC1x}
      webpPC2x={imgGiveBackWebpPC2x}
      webpSP2x={imgGiveBackWebpSP2x}
      webpSP3x={imgGiveBackWebpSP3x}
      alt="img_give_back"
    />
    <div className="give-contents">
      <BlockHeaderCenter>
        星野リゾートで過ごす時間を
        <br />
        贈り物に。
      </BlockHeaderCenter>
      <ul>
        <li>日頃の“ありがとう”を伝えるために。</li>
        <li>
          <span className="quotes">“</span>
          大切な方に贈る記念日のお祝いに。
          <span className="quotes">”</span>
        </li>
        <li>
          <span className="quotes">“</span>
          パーティやイベントの景品に。
          <span className="quotes">”</span>
        </li>
        <li>贈り物をする様々なシーンで</li>
        <li>ご利用いただけます。</li>
      </ul>

      <div className="campaign">
        <NavLink to="/contact">
          <Button buttonType="C">
            キャンペーン、プロモーションなどで使用をご検討の方
          </Button>
        </NavLink>
      </div>
    </div>
  </div>
);

const commonStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  position: relative;

  ${Image} {
    img {
      width: 100%;
      height: auto;
    }
  }

  .give-contents {
    position: absolute;
    background-color: ${Colors.white1};

    ul {
      letter-spacing: 1px;

      padding-left: 0;

      li {
        ${FontStyles.text6}
        text-align: center;
        list-style: none;

        .quotes {
          color: ${Colors.orange1};
        }
      }
    }

    .campaign {
      display: block;
      text-align: center;

      ${Button} {
        margin: 0;
        cursor: pointer;
      }
    }
  }
  @media all and (-ms-high-contrast: none) and (min-width:1025px) {
    *::-ms-backdrop, .give-contents {
      margin-left: -75%;
      margin-top: -25%;
    }
  }
  @media all and (-ms-high-contrast: none) and (max-width:1024px) {
    *::-ms-backdrop, .give-contents {
      margin-top: -35% !important;
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .give-contents {
    height: 705px;
    width: 688px;
    box-shadow: 0 0 12px -2px #787878;

    ${BlockHeaderCenter} {
      margin: 80px auto 66px;

      br {
        display: none;
      }
    }

    ul {
      li {
        margin-bottom: 24px;

        &:last-of-type {
          margin-bottom: 64px;
        }
      }
    }

    .campaign {
      margin: 48px 0 0;

      ${Button} {
        height: 82px;
        padding: 0 40px;
      }
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${Image} {
    picture {
      width: 100%;
    }
  }

  .give-contents {
    left: 0;
    right: 0;
    box-shadow: 0 0 25px -11px #787878;
    padding: 0 24px;
    margin: auto 16px;

    ${BlockHeaderCenter} {
      margin: 36px auto;
    }

    ul {
      li {
        margin-bottom: 14px;

        &:last-of-type {
          margin-bottom: 40px;
        }
      }
    }

    .campaign {
      margin: 40px 0;

      ${Button} {
        height: 70px;
        padding: 0 40px;
      }
    }
  }
`;

export default applyStyles(Give)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/Give.js